import React, { useEffect } from 'react';
import { Box, Grid, Button, Typography } from '@mui/material';
import CustomTable from '../../components/table/GroupTable';
import Addcategory from './Addgroup';
import { useDispatch, useSelector } from "react-redux";
import { getgroup } from '../../slices/group';

const columns = [
  { id: 'sno', label: 'S.No', minWidth: 150, align:'start' },
  { id: 'name', label: 'Category', minWidth: 150, align:'start' },
  { id: 'action', label: 'Action', minWidth: 100, align:'center', actionType: [{edit: true, delete: true}] },
];

  const Group = ({setLoader}) => {

  const {groups: categoryData} = useSelector((state) => state.group);

  const dispatch = useDispatch();

  const rows = categoryData?.map((va, index)=>{
    return{...va, sno: index+1}
  })

  useEffect(()=>{
    setLoader(true)
      dispatch(getgroup())
      .then(() => {
        setLoader(false);
      })
      .catch(()=>{
        setLoader(false);
      })
  }, [])
  return (
    <div className="content">
      <Box>
        <Grid container spacing={2} sx={{ paddingBottom: 2, alignItems:'center' }}>
          <Grid item xs={6} sx={{paddingTop: 0}}>
           <Typography variant='h6' sx={{fontWeight:'bold'}} className='headline'>  Manage Groups</Typography>
          </Grid>
          <Grid item xs={6} sx={{textAlign: 'end', paddingTop: 0}}>
            <Addcategory setLoader={setLoader}/>
          </Grid>
        </Grid>
      </Box>
      <Box>
        <CustomTable setLoader={setLoader} columns={columns} rows={categoryData ? rows : []} />
      </Box>
    </div>
  );
}

export default Group;